<template>
    <v-card id="boxshadow" elevation="8" class="dashboard-card m-1 cursor-pointer zoom">
        <div class="custom-icon">
            <v-icon x-large>
                {{cardData.icon}}
            </v-icon>
        </div>
        <v-divider></v-divider>

        <div class="custom-data card-footer">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs"
                          v-on="on"
                          class="d-inline-block text-truncate">{{cardData.name}}</span>
                </template>
                <span>{{cardData.name}}</span>
            </v-tooltip>
            <slot></slot>
        </div>
    </v-card>

</template>

<script>

    export default {
        name: "hoverCard",
        props: {
            cardData: Object,

        },
        methods: {

        }
    };
</script>

<style lang="scss" scoped>
    .dashboard-card {
        padding: 2rem 0rem 0rem 0rem;
        margin: 1rem;
        background: deepskyblue !important;

        .custom-icon {
            i {
                color: #81C784 !important;
                padding-bottom: 1rem;
            }
        }

        a {
            .card-footer {
                text-decoration: none;
            }
        }

        .custom-icon, .custom-data {
            padding: 0.5rem;
            display: flex;
            justify-content: center;
        }
    }

    .card-footer {
        background-color: #f0f0f0;
        background: linear-gradient(to bottom, #efeeed7a, #b3b3b3);
    }
</style>
